export enum AppReduxActions {
  SAVE_CONFIG = "SAVE_CONFIG",
  SAVE_EMPLOYEES = "SAVE_EMPLOYEES",
}

const saveConfig = (payload: any): any => ({
  type: AppReduxActions.SAVE_CONFIG,
  payload,
});

const saveEmployees = (payload: any): any => ({
  type: AppReduxActions.SAVE_EMPLOYEES,
  payload,
});

export const AppActions = {
  saveConfig,
  saveEmployees,
};
